import React from 'react';
import { Col, Row } from 'syngenta-digital-cropwise-react-ui-kit';

interface SectionCardProps {
  title?: string;
  children: React.ReactNode;
  headerContent?: React.ReactNode;
  bodyHeight?: number | string;
  isOptional?: boolean;
  button?: React.ReactNode;
  toggleContent?: React.ReactNode;
  autoHeight?: boolean;
  hasWrapper?: boolean;
  bannerContent?: React.ReactNode;
  showBanner?: boolean;
  hasMarginBottom?: boolean;
}

const FormSection: React.FC<SectionCardProps> = ({
  title,
  headerContent,
  children,
  bodyHeight,
  isOptional = false,
  button,
  toggleContent,
  autoHeight = false,
  hasWrapper = true,
  bannerContent,
  showBanner = true,
  hasMarginBottom = true
}) => {
  const containerStyle =
    autoHeight && bodyHeight
      ? { minHeight: bodyHeight }
      : { height: bodyHeight ?? 'auto' };

  return (
    <section className={hasWrapper ? 'pt-2' : ''}>
      {title && toggleContent && (
        <Row prefixCls="syt-antd-row" className="mb-6">
          <Col prefixCls="syt-antd-col" span={24}>
            {toggleContent}
          </Col>
        </Row>
      )}
      {bannerContent && showBanner && (
        <Row prefixCls="syt-antd-row" className="mb-4">
          <Col prefixCls="syt-antd-col" span={24}>
            {bannerContent}
          </Col>
        </Row>
      )}
      <Row prefixCls="syt-antd-row" className="items-end mb-2 pl-4">
        {title ? (
          <h1
            className="text-base font-semibold text-neutral-70"
            aria-label={isOptional ? `${title} (optional)` : title}
          >
            {title}
            {isOptional && (
              <span
                className="text-sm font-normal text-neutral-50 ml-1"
                aria-hidden="true"
              >
                {' (optional)'}
              </span>
            )}
          </h1>
        ) : (
          // Empty state for title to fill container width
          <div />
        )}
        <Col prefixCls="syt-antd-col" flex="auto">
          {headerContent}
        </Col>
        <Col prefixCls="syt-antd-col">
          {button && <div className="shrink-0">{button}</div>}
        </Col>
      </Row>
      {!title && toggleContent && (
        <Row prefixCls="syt-antd-row" className="mb-2 pl-4">
          <Col prefixCls="syt-antd-col" span={24}>
            {toggleContent}
          </Col>
        </Row>
      )}
      {hasWrapper ? (
        <div
          className={`bg-white rounded-lg shadow-sm-card p-4 ${
            hasMarginBottom ? 'mb-10' : ''
          }`}
          style={containerStyle}
        >
          {children}
        </div>
      ) : (
        children
      )}
    </section>
  );
};

export default FormSection;
